module.exports = new __parcel__URL__("darkshield.74a5271c.png").toString();